module.exports = __webpack_public_path__ + "assets/img/profile-attributes-active.75e2f30d.svg";